import Mapper from './Mapper'
import { Api } from '../../definitions/Api'

/**
 * This classed is used to map the API response (from getApis API) in a format used by the React components
 */
export default class ApiMapper extends Mapper {

  constructor(unformattedObjects: any[]) {
    super(unformattedObjects)
  }

  formatObject(unformattedObject: any): Api {
    return {
      id: unformattedObject.id,
      name: unformattedObject.name,
      version: unformattedObject.version,
      creationDate: unformattedObject.createdDate,
      description: unformattedObject.description
    }
  }

  format(): Api[] {
    return this.unformattedObjects.map(x => this.formatObject(x))
  }
}

